<template>
  <div>
    <formmodal></formmodal>
  </div>
</template>

<script>
import formmodal from "../forms/FormModal";
export default {
  components: {
    formmodal
  }
};
</script>

<style></style>
